import { useQuery } from '@tanstack/react-query';

import { fetchUsuarioByCuit, type UsuarioByCuitResponse } from '../api/balance.api';

const FIVE_MINUTES = 1000 * 60 * 5;

export function useAccountsByCuitQuery(cuit: string | undefined) {
  const normalized = cuit?.replace(/\D/g, '') ?? '';
  const enabled = normalized.length === 11;
  return useQuery<UsuarioByCuitResponse, Error>({
    queryKey: ['accounts-by-cuit', normalized],
    queryFn: () => fetchUsuarioByCuit(normalized),
    enabled,
    staleTime: FIVE_MINUTES,
    refetchOnWindowFocus: false,
  });
}
